module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAASCAYAAABFGc6jAAAAAXNSR0IArs4c6QAAAR9JREFUSEu91D1uwkAQBeD3gAPEsaHiEJyBSJHSpUukpI7ScAfScQREDYWlFFyAnCFdDpCOQJw2Emai2Jg/s7tjZHDhZn8+z87zEmd6eApHZj9tSPwE4APBZY/kb+mQTOd3IEYQqSZFkF3W/ZdSoRySQiHr/n1pkAGJweo1g4u3UiAjInhgww+Twv5fMv2+AWWQnmmlw8Aba0OiQTbQ1/wTIs1V82JsfYkN1CKHobSBTqwIsoFm0S1k+bqOpAMriqyhtE97+Tdg2nn7R76TOtcmrnFbP3PxNm8mfZDP2uO1VpQNHsRyK92B2V5i/GGtmCKVqoqslR2B7KTO1MhVZUOI1EAuIHjMrhXt7aGCkuhHUQuL5RVqlQk9770IkM39A/xyzBOdGw9rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/three-order-activity/coupon-receviced-gou.png
// module id = nOas
// module chunks = 4